// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"sv_a bht_b bht_bj","HomeBaseBanner__hint":"sv_b bht_vh","HomeBaseBanner__link":"sv_c"};